import cx from 'classnames';

import { updateUserPreference } from 'actions/user';
import SwitchButton from 'components/bellAlerts/partials/SwitchButton';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import i18n from 'i18n/config';
import { orderPlacedFromChartsSelector } from 'selectors/otherSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';

import styles from './ChartOrderbookTab.module.scss';

const showConfirmationMessageForOrderPlacedFromChart = i18n.t(
  'account:tradeSettings.generalList.showConfirmationMessageForOrderPlacedFromChart'
);

const ShowConfirmationMessageForOrderPlacedFromChart = () => {
  const orderPlacedFromCharts: boolean = useAppSelector(orderPlacedFromChartsSelector);
  const dispatch = useAppDispatch();
  const handleChange = () => {
    const eventName = orderPlacedFromCharts
      ? MIXPANEL_EVENT_NAMES.MOBILE_CHART.BOOK_ORDER_MODAL_DISABLED
      : MIXPANEL_EVENT_NAMES.MOBILE_CHART.BOOK_ORDER_MODAL_ENABLED;

    dispatch(
      updateUserPreference(
        { preferences: { orderPlacedFromCharts: !orderPlacedFromCharts } },
        { disable_notification: false }
      )
    );
    trackMixpanelEvent(eventName, {
      source: 'Charts/Book_Order',
    });
  };

  return (
    <SwitchButton
      data-testid="showConfirmationMessageForOrderPlacedFromChart"
      className={cx('flex-set flex--content-between', styles.settingsContentItemSwitch)}
      buttonText={showConfirmationMessageForOrderPlacedFromChart}
      checked={orderPlacedFromCharts}
      onChange={handleChange}
      classes={{
        root: styles.switchRoot,
        track: styles.switchTrack,
        thumb: styles.switchThumb,
        switchBase: styles.switchBase,
        checked: styles.switchChecked,
        label: styles.switchLabel,
      }}
      disableRipple
    />
  );
};

export default ShowConfirmationMessageForOrderPlacedFromChart;
